export default {
    title: "Gestión de Documentos",
    subtitle: "Configura tipos de documentos, esquemas, atributos y entrenamiento para el agente IA",
    tabs: {
        types: "Tipos de Documento",
        connections: "Doc Connection Manager",
        training: "Entrenamiento",
    },
    types: {
        title: "Tipos de Documento",
        description: "Gestiona los tipos de documentos disponibles en el sistema",
        newDocumentType: "Nuevo Tipo de Documento",
        filters: {
            keywordPlaceholder: "Buscar por palabra clave...",
            attributePlaceholder: "Filtrar por atributo específico",
            allAttributes: "Todos los atributos",
        },
        headers: {
            key: "Clave",
            label: "Etiqueta",
            description: "Descripción",
            schemasCount: "Núm. Esquemas",
            attributesCount: "Núm. Atributos",
            actions: "Acciones",
        },
        modal: {
            new: "Nuevo Tipo de Documento",
            edit: "Editar Tipo de Documento",
            fields: {
                key: "Clave",
                keyPlaceholder: "ej.: bill_of_lading",
                label: "Etiqueta",
                labelPlaceholder: "ej.: Conocimiento de Embarque",
                description: "Descripción",
                descriptionPlaceholder: "Descripción del tipo de documento",
            },
        },
        actions: {
            edit: "Editar",
            delete: "Eliminar",
            viewSchemas: "Esquemas",
            viewAttributes: "Atributos",
        },
    },
    schemas: {
        title: "Esquemas de Documento",
        description: "Gestiona esquemas para cada tipo de documento con variantes verticales",
        newSchema: "Nuevo Esquema",
        searchPlaceholder: "Buscar por nombre, tipo...",
        documentTypePlaceholder: "Filtrar por tipo de documento",
        regionPlaceholder: "Filtrar por región",
        statusPlaceholder: "Filtrar por estado",
        headers: {
            documentType: "Tipo de Documento",
            schemaName: "Nombre del Esquema",
            schemaCode: "Código",
            region: "Región",
            attributeCount: "Atributos",
            parserRulesCount: "Reglas Parser",
            isDefault: "Por Defecto",
            isActive: "Estado",
            actions: "Acciones",
        },
        modal: {
            new: "Nuevo Esquema",
            edit: "Editar Esquema",
            fields: {
                documentType: "Tipo de Documento",
                documentTypePlaceholder: "Seleccionar tipo de documento",
                schemaName: "Nombre del Esquema",
                schemaNamePlaceholder: "ej.: WayBill China/Asia",
                schemaCode: "Código del Esquema",
                schemaCodePlaceholder: "ej.: waybill_china_asia",
                version: "Versión",
                versionPlaceholder: "ej.: 1.0",
                description: "Descripción",
                descriptionPlaceholder: "Descripción del esquema",
                useCases: "Casos de Uso",
                useCasesPlaceholder: "Cuándo usar este esquema",
                region: "Región",
                regionPlaceholder: "ej.: asia, europe",
                countryCodes: "Códigos de País",
                countryCodesPlaceholder: "ej.: CN, JP, KR",
                carrierCodes: "Códigos de Transportista",
                carrierCodesPlaceholder: "ej.: MAEU, MSC",
                isDefault: "Esquema por Defecto",
                isActive: "Activo",
            },
        },
        actions: {
            edit: "Editar",
            delete: "Eliminar",
            viewAttributes: "Gestionar Atributos",
            parserRules: "Reglas Parser",
        },
        status: {
            active: "Activo",
            inactive: "Inactivo",
            default: "Por Defecto",
        },
    },
    schemaAttributes: {
        title: "Atributos del Esquema",
        description: "Gestiona los atributos para este esquema",
        backToSchemas: "Volver a Esquemas",
        newAttribute: "Añadir Atributo",
        searchPlaceholder: "Buscar atributo...",
        headers: {
            attributeKey: "Clave",
            label: "Etiqueta",
            type: "Tipo",
            importance: "Importancia",
            required: "Obligatorio",
            enumValues: "Valores Enum",
            metadata: "Metadatos",
            actions: "Acciones",
        },
        modal: {
            new: "Añadir Atributo",
            edit: "Editar Atributo",
            createNewAttribute: "Crear Nuevo Atributo",
            useExistingAttribute: "Usar Atributo Existente",
            fields: {
                attribute: "Atributo",
                attributePlaceholder: "Seleccionar atributo existente",
                importanceLevel: "Nivel de Importancia",
                importanceLevelPlaceholder: "Seleccionar nivel",
                importanceLevels: {
                    error: "Error si falta",
                    warning: "Advertencia si falta",
                    optional: "Opcional",
                },
                isRequired: "Obligatorio",
                displayOrder: "Orden de Visualización",
                customLabel: "Etiqueta Personalizada",
                customLabelPlaceholder: "Sobrescribir etiqueta (opcional)",
                customHelpText: "Texto de Ayuda Personalizado",
                customHelpTextPlaceholder: "Sobrescribir texto de ayuda (opcional)",
            },
        },
        importance: {
            error: "Error",
            warning: "Advertencia",
            optional: "Opcional",
        },
        actions: {
            edit: "Editar",
            remove: "Eliminar",
        },
    },
    attributes: {
        title: "Atributos Globales",
        description: "Gestiona atributos reutilizables para todos los esquemas",
        newAttribute: "Nuevo Atributo",
        searchPlaceholder: "Buscar por clave, etiqueta...",
        dataTypePlaceholder: "Filtrar por tipo de dato",
        categoryPlaceholder: "Filtrar por categoría",
        globalPlaceholder: "Filtrar por global",
        headers: {
            attributeKey: "Clave",
            label: "Etiqueta",
            dataType: "Tipo de Dato",
            category: "Categoría",
            isGlobal: "Global",
            usageCount: "Usos",
            actions: "Acciones",
        },
        modal: {
            new: "Nuevo Atributo",
            edit: "Editar Atributo",
            fields: {
                attributeKey: "Clave del Atributo",
                attributeKeyPlaceholder: "ej.: shipper_name",
                label: "Etiqueta",
                labelPlaceholder: "ej.: Nombre del Expedidor",
                description: "Descripción",
                descriptionPlaceholder: "Descripción del atributo",
                dataType: "Tipo de Dato",
                dataTypePlaceholder: "Seleccionar tipo de dato",
                enumValues: "Valores Enum",
                enumValuesPlaceholder: "Añadir valores (uno por línea)",
                enumValuesHelp: "Solo para tipo enum",
                metadata: "Metadatos",
                metadataPlaceholder: '{"key": "value"}',
                metadataHelp: "Solo para tipo json - JSON válido",
                validationRules: "Reglas de Validación",
                validationRulesPlaceholder: '{"min": 0, "max": 100}',
                inputType: "Tipo de Entrada",
                inputTypePlaceholder: "ej.: text, number, date",
                placeholder: "Placeholder",
                placeholderPlaceholder: "Texto placeholder",
                helpText: "Texto de Ayuda",
                helpTextPlaceholder: "Texto de ayuda para el usuario",
                category: "Categoría",
                categoryPlaceholder: "ej.: parties, cargo, dates",
                displayOrder: "Orden de Visualización",
                isGlobal: "Global",
            },
        },
        actions: {
            edit: "Editar",
            delete: "Eliminar",
        },
        dataTypes: {
            string: "Cadena",
            number: "Número",
            date: "Fecha",
            datetime: "Fecha/Hora",
            boolean: "Booleano",
            array: "Array",
            object: "Objeto",
            email: "Email",
            url: "URL",
            phone: "Teléfono",
        },
    },
    connections: {
        title: "Doc Connection Manager",
        description: "Vincula atributos de esquemas de diferentes tipos de documentos para facilitar la validación entre documentos",
        newConnection: "Nueva Conexión",
        searchPlaceholder: "Buscar conexión...",
        headers: {
            source: "Origen",
            target: "Destino",
            validationRule: "Regla de Validación",
            created: "Creado",
            actions: "Acciones",
        },
        modal: {
            new: "Nueva Conexión",
            edit: "Editar Conexión",
            source: "Origen",
            target: "Destino",
            fields: {
                sourceDocumentType: "Tipo de Documento Origen",
                sourceSchema: "Esquema Origen",
                sourceAttribute: "Atributo Origen",
                targetDocumentType: "Tipo de Documento Destino",
                targetSchema: "Esquema Destino",
                targetAttribute: "Atributo Destino",
                validationRule: "Regla de Validación",
            },
        },
        validationRules: {
            mustMatch: "Deben Coincidir",
            mustBeDifferent: "Deben Ser Diferentes",
            sourceContainsTarget: "Origen Contiene Destino",
            targetContainsSource: "Destino Contiene Origen",
            mustReference: "Debe Hacer Referencia",
            mustBeSimilar: "Deben Ser Similares",
        },
        actions: {
            edit: "Editar",
            delete: "Eliminar",
        },
    },
    training: {
        title: "Documentos de Entrenamiento",
        description: "Sube documentos para el entrenamiento del agente IA",
        uploadDocuments: "Subir Documentos",
        uploadArea: "Arrastra archivos aquí o haz clic para seleccionar",
        supportedFormats: "Formatos soportados: PDF, PNG, JPG",
        searchPlaceholder: "Buscar documento...",
        documentTypePlaceholder: "Filtrar por tipo",
        statusPlaceholder: "Filtrar por estado",
        headers: {
            fileName: "Nombre del Archivo",
            documentType: "Tipo",
            status: "Estado",
            uploadDate: "Fecha de Subida",
            extractionScore: "Puntuación de Extracción",
            validationScore: "Puntuación de Validación",
            detectedSchema: "Esquema Detectado",
            actions: "Acciones",
        },
        status: {
            pending: "Pendiente",
            processing: "Procesando",
            completed: "Completado",
            failed: "Fallido",
        },
        validationStatus: {
            correct: "Correcto",
            incorrect: "Incorrecto",
            pending: "Por Validar",
        },
        actions: {
            viewDetails: "Detalles",
            delete: "Eliminar",
            correct: "Correcto",
            incorrect: "Incorrecto",
            loading: "Cargando...",
        },
        breadcrumb: {
            trainingDocuments: "Documentos de Entrenamiento",
        },
        detail: {
            title: "Detalles del Proceso de Entrenamiento",
            backToList: "Volver a la Lista",
            documentTitle: "Documento",
            extractedDataTitle: "Datos Extraídos por Proveedor",
            infoTitle: "Información del Proceso y Entrenamiento",
            notFound: {
                title: "Documento no encontrado",
                message: "El documento de entrenamiento solicitado no existe.",
                backToList: "Volver a la Lista",
            },
            infoFields: {
                documentType: "Tipo de Documento",
                status: "Estado",
                dataset: "Dataset",
                datasetVersion: "Versión del Dataset",
                schema: "Esquema",
                detectedSchema: "Esquema Detectado",
                extractionScore: "Puntuación de Extracción",
                validationScore: "Puntuación de Validación",
                createdAt: "Fecha de Creación",
                updatedAt: "Última Actualización",
                aiProviders: "Proveedores IA Utilizados",
                customVariables: "Variables Personalizadas",
                notes: "Notas",
            },
            tableHeaders: {
                attribute: "Atributo",
                extractedValue: "Valor Extraído",
                confidence: "Confianza",
                validationStatus: "Estado de Validación",
                actions: "Acciones",
            },
        },
        modal: {
            details: "Detalles del Procesamiento",
            fields: {
                fileName: "Nombre del Archivo",
                documentType: "Tipo de Documento",
                datasetName: "Nombre del Dataset",
                datasetVersion: "Versión del Dataset",
                status: "Estado",
                extractionScore: "Puntuación de Extracción",
                validationScore: "Puntuación de Validación",
                detectedSchema: "Esquema Detectado",
                processingTime: "Tiempo de Procesamiento",
                extractedFields: "Campos Extraídos",
                validationIssues: "Problemas de Validación",
            },
        },
        upload: {
            success: "Documentos subidos con éxito",
            error: "Error en la subida",
            processing: "Procesando...",
        },
    },
    parserRules: {
        title: "Reglas Parser",
        description: "Gestiona las reglas en Lenguaje Natural para el agente Parser",
        status: {
            active: "Activa",
            inactive: "Inactiva",
        },
        priority: "Prioridad",
        actions: {
            add: "Añadir Regla",
            edit: "Editar",
            delete: "Eliminar",
            cancelEdit: "Cancelar Edición",
        },
        modal: {
            title: "Reglas Parser",
            existingRules: "Reglas Existentes",
            noRules: "No hay reglas definidas para este esquema",
            addRule: "Añadir Nueva Regla",
            editRule: "Editar Regla",
            fields: {
                ruleName: "Nombre de la Regla",
                ruleNamePlaceholder: "ej.: Validación Código Contenedor",
                naturalLanguageRule: "Regla en Lenguaje Natural",
                naturalLanguageRulePlaceholder: "Escribe la regla en lenguaje natural que el agente Parser debe seguir...",
                naturalLanguageRuleHelp: "Describe en lenguaje natural cómo el agente debe tratar el documento una vez clasificado con este esquema",
                description: "Descripción",
                descriptionPlaceholder: "Descripción opcional de la regla",
                priority: "Prioridad",
                isActive: "Activa",
            },
        },
    },
    modal: {
        cancel: "Cancelar",
        save: "Guardar",
        create: "Crear",
        delete: "Eliminar",
        close: "Cerrar",
        confirmDelete: "Confirmar Eliminación",
        confirmDeleteMessage: "¿Estás seguro de que quieres eliminar este elemento? Esta acción no se puede deshacer.",
    },
    loading: "Cargando...",
    noData: {
        title: "No hay datos disponibles",
        message: "No hay elementos para mostrar",
        createFirst: "Crear el primer elemento",
    },
    breadcrumb: {
        documentTypes: "Tipos de Documento",
        schemas: "Esquemas",
        attributes: "Atributos",
    },
    common: {
        yes: "Sí",
        no: "No",
        selectFile: "Seleccionar Archivo",
        selectedFiles: "Archivos seleccionados:",
        upload: "Subir",
        selectAttribute: "Seleccionar un atributo",
        selectAtLeastOneFile: "Selecciona al menos un archivo",
        insertAliasPerLine: "Inserta un alias por línea",
        invalidJson: "JSON no válido",
        global: "Global",
        specific: "Específico",
    },
};
